import bInput from '../b-input/b-input.vue'

bInput.install = function (Vue) {
  Vue.component(bInput.name, bInput)
}

export default bInput
